import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P24-E1',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page24/E1/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page24/E1/2.jpg' }],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P24-E2',
    audio: 'img/FriendsPlus/Page24/Audio/audio-e2-p24.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/tieude-e2-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page24/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh1-e2-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/8.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh2-e2-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E2/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page24/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page24/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/12.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh3-e2-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/14.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh4-e2-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E2/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page24/E2/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page24/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/18.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh5-e2-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/20.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh6-e2-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E2/21.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page24/E2/22.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P24-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page24/E3/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E3/1.jpg'},
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E3/2.jpg'},
        { url: 'img/FriendsPlus/Page24/E3/3.jpg', input: 1, isCorrect: true},
        { url: 'img/FriendsPlus/Page24/E3/4.jpg', input: 1},
        { url: 'img/FriendsPlus/Page24/E3/5.jpg'},
        { url: 'img/FriendsPlus/Page24/E3/6.jpg', input: 2, isCorrect: true},
        { url: 'img/FriendsPlus/Page24/E3/7.jpg', input: 2},
        { url: 'img/FriendsPlus/Page24/E3/8.jpg'},
        { url: 'img/FriendsPlus/Page24/E3/9.jpg', input: 3},
        { url: 'img/FriendsPlus/Page24/E3/10.jpg', input: 3, isCorrect: true},
        { url: 'img/FriendsPlus/Page24/E3/11.jpg'},
      ],      
    ],
  },


}

export default json;